<div fxLayout="column" fxLayoutAlign="start stretch" class="w-100 h-100" fxLayoutGap="40px">
    @for (group of classificationGroupPanelData; track group) {
        <div fxLayout="column" fxLayoutAlign="start stretch" class="w-100 h-100" fxLayoutGap="24px">
            @if (group.groupName) {
                <div class="t1-semi-bold c-primary-gray-900">{{ group.groupName }}</div>
            }
            <div class="panel-grid-container">
                @for (item of group.items; track item) {
                    <af-classification-panel [item]="item" (click)="clickListener.emit(item)"/>
                }
            </div>
        </div>
    }
</div>
